import { BankConfig, popularBanksPerCountry } from '../constants/popularBanksPerCountry'
import { Bank } from '../types/bank'

export type PopularBankConfig = Bank & BankConfig

export const getPopularBanksData = (
  countryId: string,
  banks: Bank[],
  popularBanksListLength?: number,
): PopularBankConfig[] => {
  const countryConfig = popularBanksPerCountry[countryId]
  if (!countryConfig) {
    return []
  }

  const configToUse = popularBanksListLength ? countryConfig.slice(0, popularBanksListLength) : countryConfig

  return configToUse.reduce<PopularBankConfig[]>((acc, config) => {
    const bank = banks.find((bank: Bank) => bank.externalId === config.externalId)
    if (bank) {
      acc.push({ ...bank, ...config })
    }
    return acc
  }, [])
}
